<template>
    <div class="h-full flex-shrink-0 lg:w-[600px] lg:max-w-[600px] bg-stone-100">
        <main-menu-panel />
        <transition name="slide-in-from-left" @after-enter="afterEnterTransition">
            <colors-panel v-if="selectedStep === 'colors'" />
        </transition>
        <transition name="slide-in-from-left" @after-enter="afterEnterTransition">
            <graphic-panel v-if="selectedStep === 'images'" />
        </transition>
        <transition name="slide-in-from-left" @after-enter="afterEnterTransition">
            <text-panel v-if="selectedStep?.startsWith('text')" />
        </transition>
        <transition name="slide-in-from-left" @after-enter="afterEnterTransition">
            <monogram-panel v-if="selectedStep === 'monogram'" />
        </transition>
        <transition name="slide-in-from-left" @after-enter="afterEnterTransition">
            <review-order-panel v-if="selectedStep === 'review'" />
        </transition>
        <transition name="slide-in-from-left" @after-enter="afterEnterTransition">
            <group-ordering-panel v-if="selectedStep === 'group'" />
        </transition>
        <design-side v-if="selectedStep === 'side'" />
        <product-details v-if="selectedStep === 'info'" />
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import MainMenuPanel from './MainMenuPanel.vue';
    import ColorsPanel from '../ColorsPanel.vue';
    import DesignSide from '../../DesignSide.vue';
    import GraphicPanel from '../GraphicPanel.vue';
    import TextPanel from '../TextPanel.vue';
    import ProductDetails from '../../ProductDetails.vue';
    import GroupOrderingPanel from '../GroupOrderingPanel.vue';
    import ReviewOrderPanel from '../ReviewOrderPanel.vue';
    import MonogramPanel from '../MonogramPanel.vue';

    export default {
        components: {
            ColorsPanel,
            GraphicPanel,
            TextPanel,
            DesignSide,
            ProductDetails,
            GroupOrderingPanel,
            ReviewOrderPanel,
            MainMenuPanel,
            MonogramPanel,
        },
        name: 'ParentMenuPanel',
        computed: {
            ...mapState([
                'selectedStep',
                'selectedStepParameters',
                'isGroupOrder',
            ]),

            ...mapGetters(['returnTo']),
            ...mapActions(['globalEvent']),
            returnTo() { return !!this.selectedStepParameters && this.selectedStepParameters.returnTo; },
        },
        methods: {
            afterEnterTransition() {
                // this.globalEvent({ name: 'afterEnterTransition' });
            },
        },
    };
</script>
